import { ChangeDetectionStrategy, Component, input, inject } from '@angular/core';
import { Bucket } from '../../types';
import { BucketService } from '../../services/bucket.service';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-balance-amount',
  templateUrl: './balance-amount.component.html',
  styleUrl: './balance-amount.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CurrencyPipe],
})
export class BalanceAmountComponent {
  bucketService = inject(BucketService);

  bucket = input<Bucket>();
  showDecimals = input<boolean>();

  isPositiveBalance(): boolean {
    return (this.bucket()?.fund?.balance ?? 0) > 0;
  }

  isWarningBalance(): boolean {
    const bucket = this.bucket();
    return bucket ? this.bucketService.isIncomeAndWithinPaycheck(bucket) : false;
  }

  isNegativeBalance(): boolean {
    return (this.bucket()?.fund?.balance ?? 0) < 0 && !this.isWarningBalance();
  }
}
